<wl-experience-editor>
  <ng-template wlLive>
    @if (rendering && viewModel$ | async; as vm) {
      <div class="p-4 bg-white" [id]="solarPanelsSuitabilityCheckFormId">
        @if (vm.isVisible) {
          @if (roofMightBeSuitable(vm.criteria)) {
            <wl-solar-panels-suitability-check
              [rendering]="rendering"
              [formState]="vm.formState"
              [trackToolConfig]="trackToolConfig"
              [showAsbestosQuestion]="vm.questions.asbestos"
              [showRoofTypeQuestion]="vm.questions.roofType"
              [showRenovationDateQuestion]="vm.questions.renovationDate"
              [asbestosOptions]="asbestosOptions"
              [roofTypeOptions]="roofTypeOptions"
              [roofReplacedOptions]="roofReplacedOptions"
              [maximumRoofAge]="vm.roofMaxAge"
              (submitForm)="submit($event, vm.formState.isValid)"
            ></wl-solar-panels-suitability-check>
          } @else {
            <wl-error-card
              [message]="rendering?.fields?.UnsuitableHouseMessage"
              [mode]="'content'"
              wlAutomationId="unsuitable-roof-error"
            ></wl-error-card>
          }
        } @else {
          <sc-placeholder
            name="column-1"
            [rendering]="rendering"
          ></sc-placeholder>
        }
      </div>
      @if (formIsInvalid$ | async) {
        <ng-template *ngTemplateOutlet="roofUnsuitable"></ng-template>
      }
    }
  </ng-template>
  <ng-template wlPreview>
    <ng-template *ngTemplateOutlet="placeholder"></ng-template>
    <ng-template *ngTemplateOutlet="roofUnsuitable"></ng-template>
  </ng-template>
</wl-experience-editor>

<ng-template #placeholder>
  <sc-placeholder name="column-1" [rendering]="rendering"></sc-placeholder>
</ng-template>

<ng-template #roofUnsuitable>
  <wl-error-card
    [message]="rendering?.fields?.UnsuitableHouseMessage"
    [mode]="'content'"
    wlAutomationId="unsuitable-roof-error"
  ></wl-error-card>
</ng-template>
